import { action } from 'typesafe-actions';
import { ISendToPartnerRequest, SendToPartnerActionTypes } from './types';

export const initiateSendToPartnerRequest = (request: ISendToPartnerRequest) => action(SendToPartnerActionTypes.INITIATE_SEND_TO_PARTNER_REQUEST, request);
export const sendToPartnerSuccess = () => action(SendToPartnerActionTypes.SEND_TO_PARTNER_SUCCESS);
export const sendToPartnerError = () => action(SendToPartnerActionTypes.SEND_TO_PARTNER_ERROR);
export const sendToPartnerReset = () => action(SendToPartnerActionTypes.SEND_TO_PARTNER_RESET);